module.exports = __webpack_public_path__ + "img/公司介绍.5132fa83.svg";